module.exports = __webpack_public_path__ + "static/media/info3.10840fe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/info3.jpg
// module id = 390
// module chunks = 0